var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('page-loading'):(_vm.error)?_c('error-message',{model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }